import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    /* ********************************************** */
    
    container: {
      paddingTop: theme.spacing(4),
    },

    /* ********************************************** */

    wunschliste: {
      marginTop: theme.spacing(4),
    },

    /* ********************************************** */

    wunschlisteLehr: {

    },

    /* ********************************************** */

  })
)

export default useStyles
